import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.css';

const Panel = ({ title, alert, children, pullUp }) => (
  <div className={classNames(
    'panel', {
      'panel--pull-up': pullUp
    })}>
    {title && 
      <div className="panel__header">
        <h2 className="panel__title">{title}</h2>
      </div>
    }
    {alert &&
      <div className="panel__alert">
        {alert}
      </div>
    }
    {children && 
      <div className="panel__body">
        {children}
      </div>
    }
  </div>
);

Panel.propTypes = {
  title: PropTypes.string,
  pullUp: PropTypes.bool,
  alert: PropTypes.element,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array
  ])
};

export default Panel;